export function ErrorBoundaryContainer({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <div className="bg-secondary-background border-l border-stroke w-full h-full flex flex-col items-center justify-center">
      {children}
    </div>
  )
}

export function ErrorBoundaryContent({
  children,
}: {
  children: React.ReactNode
}) {
  return <div className="flex flex-col gap-4 max-w-[550px]">{children}</div>
}
